import * as types from './mutation-types'

export default {
  [types.SET_CONTROL] (state, payload) {
    if (payload === null) {
      payload = {}
    }
    state.control = payload
  },
  [types.SET_CONTROLS] (state, payload) {
    state.controls = payload.data
    state.pagination = payload.meta.pagination
  },
  [types.SET_ITEMS] (state, payload) {
    state.items = payload.data
    state.itemsPagination = payload.meta.pagination
  },
  [types.SET_ITEM] (state, payload) {
    if (payload === null) {
      payload = {}
    }
    state.item = payload
  },
  [types.SET_GROUPS] (state, payload) {
    state.groups = payload.data
    state.groupsPagination = payload.meta.pagination
  },
  [types.SET_GROUP] (state, payload) {
    if (payload === null) {
      payload = {}
    }
    state.group = payload
  }
}
